import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutGLDistributionTableMultiSource extends Layout {
    sourceGLDistribution: DataSource;
    tableGLDistribution: Table;
}
